import React, { FC, useCallback, useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import ScheduleReservationCompletePop from './ScheduleReservationCompletePop';
import { RootState } from '../../../store/reducers';
import { ReservationConfirmData, ReservationDetail } from '../../../store/reducers/schedule/reservationConfirmReducer';
import { stateScheduleReservation } from '../../../store/reducers/schedule/scheduleReservationStateReducer';
import {
  GET_SCHEDULE_RESERVATION_COMPLETE_DISPATCH,
  POST_SCHEDULE_CANCEL_WAIT_REQUEST,
  POST_SCHEDULE_RESERVATION_UPDATE_INITIAL,
  POST_SCHEDULE_RESERVATION_UPDATE_REQUEST,
} from '../../../store/actions';
import { ScheduleReservationPostType } from '../../../store/reducers/schedule/scheduleReservationPostReducer';
import FW from '../../../config/word.json';

interface Props {
  modalShow: boolean;
  onModalShow: () => void;
  onRefresh: () => void;
}

const ScheduleReservationPop: FC<Props> = ({ modalShow, onModalShow, onRefresh }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [reservationCompletePopModal, setReservationCompletePopModal] = useState(false);

  const [companionNumList, setCompanionNumList] = useState<number[]>([]);
  const [isFullBooked, setIsFullBooked] = useState(false); // 全部残り数が０のフラグ
  const [reservationDateTime, setReservationDateTime] = useState('');
  const [selectCompanionNum, setSelectCompanionNum] = useState(0);
  const [selectReservationDetail, setSelectReservationDetail] = useState<ReservationDetail>();
  const [errorMessage, setErrorMessage] = useState('');

  const { isGetReservationConfirmLoaded, reservationConfirmData } = useSelector<RootState, ReservationConfirmData>(
    (state) => state.schedule.getReservationConfirmReducer,
  );

  const { scheduleReservation } = useSelector<RootState, stateScheduleReservation>(
    (state) => state.schedule.scheduleReservationState,
  );

  const { scheduleReservationPost } = useSelector<RootState, ScheduleReservationPostType>(
    (state) => state.schedule.scheduleReservationPost,
  );

  useEffect(() => {
    if (reservationConfirmData?.companionUpperLimit !== undefined) {
      const limit = reservationConfirmData.companionUpperLimit;
      const numList: number[] = Array.from({ length: limit + 1 }, (_, i) => i); // 明确类型
      setCompanionNumList(numList);
    }
    const allFull = reservationConfirmData.scheduleReservationList.every((item) => item.remaining <= 0);
    setIsFullBooked(allFull);
  }, [reservationConfirmData]);

  const onChangeCompanionNum = useCallback((eve: React.ChangeEvent<HTMLSelectElement>) => {
    const companionNum = Number(eve.target.value);
    setSelectCompanionNum(companionNum);
  }, []);

  // const onChangeSelectReservationDetail = useCallback((reservationDetail: ReservationDetail) => {
  //   setSelectReservationDetail({ ...reservationDetail });
  // }, []);

  const onChangeSelectReservationDetail = useCallback((reservationDetail: ReservationDetail) => {
    return (e: React.ChangeEvent<HTMLInputElement>) => {
      setSelectReservationDetail({ ...reservationDetail });
    };
  }, []);

  useEffect(() => {
    dispatch({
      type: POST_SCHEDULE_RESERVATION_UPDATE_INITIAL,
    });
    setSelectCompanionNum(0);
    setErrorMessage('');
    setSelectReservationDetail(undefined);
  }, [dispatch, modalShow]);

  useEffect(() => {
    const year = scheduleReservation.infoDate.substring(0, 4);
    const month = parseInt(scheduleReservation.infoDate.substring(4, 6), 10).toString();
    const day = parseInt(scheduleReservation.infoDate.substring(6, 8), 10).toString();

    const formattedStartTime = `${scheduleReservation.contentStartTime.substring(
      0,
      2,
    )}:${scheduleReservation.contentStartTime.substring(2, 4)}`;

    const formattedEndTime = `${scheduleReservation.contentEndTime.substring(
      0,
      2,
    )}:${scheduleReservation.contentEndTime.substring(2, 4)}`;

    setReservationDateTime(
      `${year}年${month}月${day}日(${scheduleReservation.week}) ${formattedStartTime}~${formattedEndTime}`,
    );
  }, [scheduleReservation]);

  useEffect(() => {
    if (scheduleReservationPost.isLoaded) {
      if (scheduleReservationPost.result === 0) {
        dispatch({
          type: GET_SCHEDULE_RESERVATION_COMPLETE_DISPATCH,
          registerFlg: isFullBooked ? 2 : 1,
          clubName: scheduleReservation.clubName,
          reservationDateTime,
          cancelTime: reservationConfirmData.cancelTime,
          companionNum: selectCompanionNum,
          companionShowFlg: reservationConfirmData.companionUpperLimit !== 0,
          annexFlag: selectReservationDetail?.annexFlag,
          contentsName: reservationConfirmData.contentsName,
          eqsName: selectReservationDetail?.eqsName,
          spaceName: selectReservationDetail?.spaceName,
          clubAddress: reservationConfirmData.clubAddress,
          history,
        });
        dispatch({ type: POST_SCHEDULE_RESERVATION_UPDATE_INITIAL });
        onRefresh();
        onModalShow();
        setReservationCompletePopModal(true);
      } else {
        setErrorMessage(scheduleReservationPost.errorMessage ?? '');
        const modalDialog = document.querySelector('.modal-dialog');
        if (modalDialog) {
          modalDialog.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    }
  }, [
    dispatch,
    history,
    isFullBooked,
    onRefresh,
    onModalShow,
    reservationConfirmData.cancelTime,
    reservationConfirmData.contentsName,
    reservationConfirmData.clubAddress,
    reservationDateTime,
    scheduleReservation.clubName,
    scheduleReservationPost,
    selectCompanionNum,
    selectReservationDetail?.annexFlag,
    selectReservationDetail?.spaceName,
    selectReservationDetail?.eqsName,
    selectReservationDetail,
  ]);

  const openReservationCompletePop = useCallback(() => {
    if (!isFullBooked) {
      // 予約操作
      if (!selectReservationDetail) {
        if (reservationConfirmData.contentsClassification === 0) {
          setErrorMessage('予約枠を1つ選択してください。');
        } else {
          setErrorMessage('予約枠を1つ選択してください。');
        }
        const modalDialog = document.querySelector('.modal-dialog');
        if (modalDialog) {
          modalDialog.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        return;
      }
      dispatch({
        type: POST_SCHEDULE_RESERVATION_UPDATE_REQUEST,
        payload: {
          contentsId: scheduleReservation.contentsId, // コンテンツコード
          eqsId: selectReservationDetail.eqsId, // 設備シフトID
          contentsDate: scheduleReservation.infoDate, // コンテンツ日付
          startTime: scheduleReservation.contentStartTime, // コンテンツ開始時間
          endTime: scheduleReservation.contentEndTime, // コンテンツ終了時間
          memberId: sessionStorage.getItem('memberID'), // 会員番号
          companion: selectCompanionNum, // 同行者数
        },
        history,
      });
    } else {
      // キャンセル待ち
      dispatch({
        type: POST_SCHEDULE_CANCEL_WAIT_REQUEST,
        payload: {
          contentsId: scheduleReservation.contentsId, // コンテンツコード
          contentsDate: scheduleReservation.infoDate, // コンテンツ日付
          startTime: scheduleReservation.contentStartTime, // コンテンツ開始時間
          endTime: scheduleReservation.contentEndTime, // コンテンツ終了時間
          memberId: sessionStorage.getItem('memberID'), // 会員番号
        },
        history,
      });
    }
  }, [
    isFullBooked,
    selectReservationDetail,
    dispatch,
    scheduleReservation.contentsId,
    scheduleReservation.infoDate,
    scheduleReservation.contentStartTime,
    scheduleReservation.contentEndTime,
    selectCompanionNum,
    history,
  ]);

  const onCloseModal = useCallback(() => {
    onModalShow();
    onRefresh();
  }, [onRefresh, onModalShow]);

  return (
    <>
      <Modal
        show={modalShow}
        onHide={onCloseModal}
        animation
        dialogClassName="p-modal-member__dialog p-modal-member__dialog--width1102 schedule"
        contentClassName="p-modal-member__content"
      >
        {/* <Modal.Header closeButton> */}
        {/*  <Modal.Title>自定义 Content Class</Modal.Title> */}
        {/* </Modal.Header> */}
        <Modal.Body className="p-modal-member__body">
          <button type="button" className="p-modal-member__close-button" aria-label="閉じる" onClick={onCloseModal} />
          <div className="p-modal-member__container">
            <div className="p-modal-member__header">
              <div className="p-modal-member__title p-modal-member__title--medium">プログラム予約</div>
              {isGetReservationConfirmLoaded && isFullBooked ? (
                <div className="p-modal-member__title p-modal-member__title--small">
                  {scheduleReservation.cancelWaitNotice === '1'
                    ? '現在満席ですがキャンセル待ち予約が可能です。'
                    : '現在満席のためご予約いただけません。'}
                </div>
              ) : (
                <></>
              )}
            </div>
            {isGetReservationConfirmLoaded && (
              <div className="p-modal-member__inner u-sp-gap15">
                {errorMessage ? (
                  <>
                    <div className="p-alert-box">
                      <div className="p-alert-box__inner">
                        <div className="p-alert-box__icon">
                          <img src="/images/icons/icon-alert.svg" alt="画像" className="p-icon p-icon--size20" />
                        </div>
                        <div className="p-alert-box__text">{errorMessage}</div>
                      </div>
                    </div>
                  </>
                ) : (
                  <></>
                )}
                <div className="p-reservation-card">
                  <div className="p-reservation-card__header p-reservation-card__header--modal">
                    <div className="p-reservation-card__row-text">
                      {scheduleReservation.clubName}
                      {reservationConfirmData.annexFlag === 1 ? (
                        <span className="c-genre-label c-genre-label--large">別館</span>
                      ) : (
                        <></>
                      )}
                    </div>
                    <div className="p-reservation-card__title">{reservationConfirmData.contentsName}</div>
                    <div className="p-reservation-card__value p-reservation-card__value--bold">
                      {reservationDateTime}
                    </div>
                  </div>

                  <div className="p-reservation-card__details p-reservation-card__details--modal">
                    {!isFullBooked ? (
                      <div className="p-reservation-card__details-text">
                        {reservationConfirmData.contentsClassification === 0
                          ? '予約枠を1つ選択してください。'
                          : '予約枠を1つ選択してください。'}
                      </div>
                    ) : (
                      <></>
                    )}
                    {reservationConfirmData && reservationConfirmData?.equipmentLayoutPicture ? (
                      <div className="p-detail-list">
                        <div className="p-detail-list__accordion-box p-detail-list__accordion-box--label-none u-gap10 u-sp-gap5">
                          <details className="c-accordion p-detail-list__store-accordion">
                            <summary className="p-detail-list__link-title">配置図を確認</summary>
                          </details>

                          <div className="p-detail-list__link-content u-pt0">
                            <div className="p-detail-list__inner">
                              <div className="p-detail-list__item p-detail-list__item--flex-start">
                                <div className="p-detail-list__value p-detail-list__value--width-full">
                                  <picture className="p-detail-list__picture">
                                    {/* <source srcSet="/images/schedule/no-image-large.jpg, /images/schedule/no-image-large@2x.jpg 2x" /> */}
                                    <img
                                      className="p-detail-list__image"
                                      src={
                                        reservationConfirmData?.equipmentLayoutPicture ??
                                        '/images/schedule/no-image-large.jpg'
                                      }
                                      alt=""
                                    />
                                  </picture>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}
                    <div className="p-reservation-card__space">
                      <div className="p-space-selector">
                        {reservationConfirmData.scheduleReservationList.map((reservationDetail, index) => (
                          <div
                            className="p-space-selector__option"
                            key={`scheduleReservation_${reservationDetail.eqsId}`}
                          >
                            <input
                              type="radio"
                              name="space-selection"
                              id={`space-selection_${reservationDetail.eqsId}`}
                              className="p-space-selector__radio"
                              onChange={onChangeSelectReservationDetail(reservationDetail)}
                              disabled={reservationDetail.remaining <= 0 || reservationDetail.bookFlag === 1}
                            />
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label
                              htmlFor={`space-selection_${reservationDetail.eqsId}`}
                              className={`p-space-selector__item  ${
                                reservationDetail.bookFlag === 1
                                  ? 'p-space-selector__item--reserved'
                                  : reservationDetail.nickName && 'p-space-selector__item--height-full'
                              }`}
                            >
                              {reservationDetail.annexFlag === 1 ? (
                                <span className="p-space-selector__tag c-genre-label">別館</span>
                              ) : (
                                <></>
                              )}
                              <div className="p-space-selector__main">
                                <div className="p-space-selector__space">{reservationDetail.eqsName}</div>
                                <div className="p-space-selector__white-box">
                                  <div className="p-space-selector__group">
                                    <div className="p-space-selector__status">
                                      {reservationDetail.remaining > 0 ? (
                                        <>
                                          残り
                                          <span className="p-space-selector__number">
                                            {reservationDetail.remaining}
                                          </span>
                                          名{' '}
                                        </>
                                      ) : (
                                        <span className="p-space-selector__sold-out">FULL</span>
                                      )}
                                    </div>
                                    <div className="p-space-selector__text">{reservationDetail.spaceName}</div>
                                  </div>

                                  {reservationDetail.nickName ? (
                                    <div
                                      className={`p-space-selector__user-group ${
                                        reservationDetail.remaining <= 0 ? 'p-space-selector__user-group--disabled' : ''
                                      }`}
                                    >
                                      {reservationDetail.nickName}
                                    </div>
                                  ) : (
                                    <></>
                                  )}
                                </div>
                              </div>
                            </label>
                            {/* {reservationDetail.remaining <= 0 ? ( */}
                            {/*  <div className="p-space-selector__note"> */}
                            {/*    ※選択したスペースが満席になりました。別のスペースを選択してください。 */}
                            {/*  </div> */}
                            {/* ) : ( */}
                            {/*  <></> */}
                            {/* )} */}
                          </div>
                        ))}
                      </div>
                    </div>
                    {isFullBooked || reservationConfirmData?.companionUpperLimit === 0 ? (
                      <></>
                    ) : (
                      <div className="p-reservation-card__companion">
                        <div className="p-reservation-card__details-text u-pb0">同行者の人数を選択してください。</div>
                        <div className="p-item-unit">
                          <div className="c-select c-select--small">
                            <select name="store" className="c-select__window" onChange={onChangeCompanionNum}>
                              {companionNumList.map((num, index) => (
                                <option key={`companionNum_${num}`} value={num}>
                                  {num}
                                </option>
                              ))}
                            </select>
                          </div>
                          <span className="p-item-unit__text">名</span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                {reservationConfirmData.contentsComment && reservationConfirmData.contentsComment.length > 0 ? (
                  <section className="p-notice">
                    <div className="p-notice__title">予約に関する注意事項</div>
                    <ul className="p-notice__list">
                      {reservationConfirmData.contentsComment &&
                        reservationConfirmData.contentsComment
                          .split('\n')
                          .filter((line) => line.trim() !== '')
                          .map((line, index) => {
                            // 使用行内容和索引组合生成相对唯一的 key
                            const uniqueKey = `${line.slice(0, 20)}-${index}`;
                            return (
                              <li key={uniqueKey} className="p-notice__item p-notice__item--size14">
                                {line}
                              </li>
                            );
                          })}
                    </ul>
                  </section>
                ) : (
                  <></>
                )}
              </div>
            )}
            <div className="p-modal-member__button-area">
              <button
                type="button"
                className="c-button c-button--secondary c-button--large c-button--prev-gray"
                onClick={onCloseModal}
              >
                戻る
              </button>
              {!isGetReservationConfirmLoaded || (isFullBooked && scheduleReservation.cancelWaitNotice === '0') ? (
                <></>
              ) : (
                <>
                  <button
                    type="button"
                    className={`c-button c-button--primary c-button--large ${!isFullBooked ? 'c-button--next' : ''}`}
                    disabled={scheduleReservationPost.isLoading}
                    onClick={openReservationCompletePop}
                  >
                    {scheduleReservationPost.isLoading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                        {FW.F_W_LOADING}
                      </>
                    ) : (
                      <>{isFullBooked ? 'キャンセル待ち登録する' : '次へ'}</>
                    )}
                  </button>
                </>
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <ScheduleReservationCompletePop
        modalShow={reservationCompletePopModal}
        onModalShow={() => setReservationCompletePopModal(false)}
        onRefresh={onRefresh}
      />
    </>
  );
};

export default ScheduleReservationPop;
